import React, { useMemo, useState } from "react"
import { motion } from "framer-motion"
import voestalpine from "../../../assets/templates/voestalpine/voestalpine.png"
import profile from "../../../assets/social_icons/profile.png"
import spark from "../../../assets/templates/voestalpine/spark.png"
import utp from "../../../assets/templates/voestalpine/utp.png"
import boehler from "../../../assets/templates/voestalpine/Boehler.png"
import fontargen from "../../../assets/templates/voestalpine/Fontargen.png"
import utp2 from "../../../assets/templates/voestalpine/UTP2.png"

import generateVcard from "../../../functions/generateVcard"
import QrModal from "../../../components/QrModal/QrModal"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "../../../components/Slider/Carousel"
import { handleProfileImageError, resolveProjectPhoto } from "../../../functions/photoHelpers"

const MainCointainer = ({ user, typeOfDevice, projectLogo, project_name }) => {

    const { name, lastname, email, phone, linkedin, photo, facebook, instagram, twitter, job, video, microsoftteams, projectId,
        excel, powerpoint, pdf, word } = user
    const resolvedPhoto = resolveProjectPhoto({ photo })
    const [showQr, setShowQr] = useState(false)
    const url = useMemo(() => {
        const data = generateVcard(user)
        return data
    }, [user])
    const handleQR = () => {
        setShowQr(!showQr)
    }
    const socialStyle = "flex justify-center drop-shadow-lg mt-2"
    const imageStyle = "xl:w-[120px] xl:h-[120px] sm:w-20 sm:h-20 flex content-center p-2"

    const socialLinks = [
        phone,
        email,
        linkedin,
        facebook,
        instagram,
        twitter,
        video,
        microsoftteams
    ].filter(link => link !== undefined && link !== null);

    // let slidesToShow = 1;
    let infinite = false;
    // let centerMode = false;

    if (socialLinks.length >= 4) {
        // slidesToShow = 3; // Si hay 4 o más enlaces, mostrar 3 slides
        infinite = true; // Si hay 4 o más enlaces, permitir un desplazamiento infinito
        // centerMode = true; // Si hay 4 o más enlaces, centrar el elemento activo
    }
    if (socialLinks.length <= 3) {
        // slidesToShow = 3; // Si hay 6 o más enlaces, mostrar 4 slides
        // centerMode = false; // Si hay 6 o más enlaces, no centrar el elemento activo
        infinite = false; // Si hay 6 o más enlaces, no permitir un desplazamiento infinito
    }

    const sliderSettings = {
        dots: false, // Muestra los puntos de navegación
        infinite: infinite, // Permite un desplazamiento infinito
        speed: 500, // Velocidad de transición en milisegundos
        slidesToShow: 3, // Número de elementos mostrados a la vez
        slidesToScroll: 1, // Número de elementos desplazados en cada cambio
        // centerMode: false, // Centra el elemento activo
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3, // Cambia el número de elementos mostrados en dispositivos más pequeños
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3, // Cambia el número de elementos mostrados en dispositivos aún más pequeños
                },
            },
        ],
    };

    return (
        <main className="flex flex-col justify-evenly md:p-20 sm:p-5 bg-white xl:h-full lg:h-full md:h-screen xs:h-auto">
            <section className="flex flex-col justify-center items-center">
                <motion.img
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className="mx-auto drop-shadow-lg" src={projectLogo ? projectLogo : voestalpine} alt="voestalpine" />
            </section>

            <section className="flex md:justify-center md:flex-col sm:flex-col sm:justify-center items-center">
                <QrModal
                    showQr={showQr}
                    setShowQr={setShowQr}
                    url={window.location.href}
                    fullname={`${name} ${lastname}`}
                />
                {/* INFORMACION PERSONAL */}
                <div className="relative w-full ">
                    <div className="absolute bg-white border border-voestalpine_primary w-full rounded-lg shadow-lg top-1/4" style={{ height: "78%" }}>
                        <motion.div
                            initial={{ opacity: 0, y: -50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}>
                            <img src={spark} alt="VIDEO" className="absolute top-0 right-0 xs:w-28 xs:h-28 lg:w-56 lg:h-56" />
                        </motion.div>
                    </div>
                    <>
                        <motion.div
                            className="flex flex-col items-center justify-center">
                            <img className="md:w-56 md:mt-0 sm:mt-5 sm:w-40 rounded-full mx-auto drop-shadow-lg border-4 border-voestalpine_primary"
                                src={resolvedPhoto ? resolvedPhoto : profile} onError={(event) => handleProfileImageError(event, profile)} alt="profile" />
                            {/* <QR></QR> */}
                            <motion.button
                                onClick={handleQR}
                                title="Ver QR"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                style={{ filter: "none" }}
                                className="relative flex flex-col items-center justify-center bg-voestalpine_primary rounded-full p-2 -top-5">
                                <svg width="20" height="20" fill="none" stroke="#ffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#ffff" stroke="none" d="M19.125 15.75h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M15.375 12.75h-2.25a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M22.125 19.5h-2.25a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M22.125 12.75h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M14.625 20.25h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375Z"></path>
                                    <path fill="#ffff" stroke="none" d="M19.125 4.5h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
                                    <path d="M21 2.25h-6.75a.75.75 0 0 0-.75.75v6.75c0 .414.336.75.75.75H21a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75Z"></path>
                                    <path fill="#ffff" stroke="none" d="M7.875 4.5h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
                                    <path d="M9.75 2.25H3a.75.75 0 0 0-.75.75v6.75c0 .414.336.75.75.75h6.75a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75Z"></path>
                                    <path fill="#ffff" stroke="none" d="M7.875 15.75h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375Z"></path>
                                    <path d="M9.75 13.5H3a.75.75 0 0 0-.75.75V21c0 .414.336.75.75.75h6.75a.75.75 0 0 0 .75-.75v-6.75a.75.75 0 0 0-.75-.75Z"></path>
                                </svg>
                            </motion.button>
                        </motion.div>
                        {/* DATOS */}
                        <div className="leading-tight mb-4 flex flex-col justify-center items-center space-y-3 xs:mt-3 lg:mt-0">
                            <motion.h1
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, ease: "easeInOut", delay: 0.8 }}
                                style={{ fontFamily: 'voestalpine-bold' }}
                                className="md:text-4xl sm:text-2xl text-center text-voestalpine_primary">{name} {lastname}</motion.h1>
                            
                            {job &&
                                <motion.h2
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 1 }}
                                    style={{ fontFamily: 'voestalpine-ligth' }}
                                    className="md:text-2xl sm:text-lg text-center text-voestalpine_primary uppercase">{job}</motion.h2>
                            }
                            
                            <motion.button
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}
                                className="bg-voestalpine_primary text-white font-bold py-2 px-4 rounded-lg text-center"
                            >
                                <a
                                    href={URL.createObjectURL(url)}
                                    download={`${String(name + lastname)
                                        .normalize("NFD")
                                        .replace(/[\u0300-\u036f]/g, "")}.vcf`}
                                    className="text-white"
                                    style={{ fontFamily: 'voestalpine-bold' }}
                                >
                                    GUARDAR CONTACTO
                                </a>
                            </motion.button>
                            
                            {/* Nuevo botón de Website con icono */}
                            <motion.a
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, ease: "easeInOut", delay: 1.6 }}
                                href="https://www.voestalpine.com/welding/es-es/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-center gap-2 text-voestalpine_primary hover:text-voestalpine_secondary transition-colors"
                                style={{ fontFamily: 'voestalpine-regular' }}
                            >
                                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667ZM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.906 15.906 0 0 0 13.97 13h-3.94Zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13ZM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11Zm5.969 0h3.938A15.904 15.904 0 0 0 12 4.248 15.906 15.906 0 0 0 10.03 11h.001Zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667Z"></path>
                                </svg>
                                <span>Website</span>
                            </motion.a>
                            
                            {/* {web &&
                                <motion.a
                                    initial={{ opacity: 0, y: -50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, ease: "easeInOut", delay: 1.3 }}
                                    className="text-xl text-center" href={web.includes("https://") ? `${web}` : `https://${web}/`}>
                                    <span style={{ fontFamily: 'voestalpine-regular' }} className="text-voestalpine_primary">{web.includes("https://") ? web.replace("https://", "") : web}</span>
                                </motion.a>
                            } */}
                        </div>
                    </>
                </div>
            </section>

            <section className="md:mt-10 xs:mt-10 xs:mb-7 md:mb-7 lg:mb-7 xl:mb-0 border-solid border border-voestalpine_primary rounded-lg">
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, ease: "easeInOut", delay: 1.6 }}
                    className="image-voestalpine slider-voestalpine custom-container"
                >
                    <Carousel
                        email={email}
                        phone={phone}
                        linkedin={linkedin}
                        microsoftteams={microsoftteams}
                        facebook={facebook}
                        instagram={instagram}
                        twitter={twitter}
                        video={video}
                        socialStyle={socialStyle}
                        imageStyle={imageStyle}
                        sliderSettings={sliderSettings}
                        typeOfDevice={typeOfDevice}
                        project_name={project_name && project_name}
                        projectId={projectId}
                        excel={excel}
                        powerpoint={powerpoint}
                        pdf={pdf}
                        word={word}
                    />
                </motion.div>
            </section>

            <section className="flex justify-center items-center">
                <a href="https://firebasestorage.googleapis.com/v0/b/promo-nfc.appspot.com/o/voestalpine%2Fpdf%2FNew%20Naming%20system%20WEAR%20070724.pdf?alt=media&token=22b6316a-4f2a-489b-a386-80bfcdd085c9" target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center">
                    <img src={utp} alt="voestalpine" className="xl:mt-8 xs:mt-0 flex items-center md:w-full md:h-full rounded-lg border border-voestalpine_primary" />
                </a>
            </section>

            <section className="flex justify-center items-center mt-5">
                {/* <div className="w-full mx-auto"> {/* Ajusta el max-w según necesites
                    <div className="w-full aspect-video rounded-lg border border-voestalpine_primary overflow-hidden">
                        <iframe
                        className="w-full h-full"
                        src="https://www.youtube.com/embed/HsfhB57CYOc?si=QFYXdg_BsEEFYNF9"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        ></iframe>
                    </div>
                </div> */}

                <div className="w-full mx-auto">
                    <div className="w-full aspect-video rounded-lg border border-voestalpine_primary overflow-hidden">
                        <video 
                        className="w-full h-full object-cover"
                        controls
                        playsInline
                        muted
                        autoPlay
                        loop
                        >
                        <source 
                            src="https://firebasestorage.googleapis.com/v0/b/promo-nfc.appspot.com/o/voestalpine%2Fvoestalpine.mp4?alt=media&token=e0c3b7d6-66d9-42ab-9648-2abd165dbfca" 
                            type="video/mp4"
                        />
                        Tu navegador no soporta el elemento de video.
                        </video>
                    </div>
                </div>
            </section>

            <section className="flex justify-center items-center mt-5">
                <div className="w-full flex flex-row items-center justify-between gap-4 xl:mt-8 xs:mt-0">
                    <img 
                        src={utp2} 
                        alt="utp2" 
                        className="rounded-lg object-contain md:h-[180px] h-[45px] w-auto" 
                    />
                    <img 
                        src={boehler} 
                        alt="boehler" 
                        className="rounded-lg object-contain md:h-[180px] h-[45px] w-auto" 
                    />
                    <img 
                        src={fontargen} 
                        alt="fontargen" 
                        className="rounded-lg object-contain md:h-[180px] h-[45px] w-auto" 
                    />
                </div>
            </section>
        </main >
    )
}

export default MainCointainer
